<ng-container *ngIf="users">
    <div class="wrapper">
        <div class="avatar-list">
            <div #openModal
                *ngIf="usersForModal.length"
                (click)="showModal()"
                class="avatar-item-outer expand-others"
                [class.selected]="isRestSelected$|async">
                <div class="avatar-item-inner"
                >+{{usersForModal.length}}</div>
            </div>
            <div *ngFor="let user of users"
            mat-raised-button
            matTooltip="{{user.name}}"
                class="avatar-item-outer"
                (click)="select(user.id)"
                [class.selected]="isSelected(user.id)">
                <div class="avatar-item-inner"
                    [style.backgroundColor]="getUserColour(user)">{{getInitials(user.name)}}</div>
            </div>
        </div>
    </div>
</ng-container>